import {
    Menu, MenuItem, Typography, colors
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { MenuButton } from '@tassat/button';
import { ActionTypes } from '@tassat/common-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

const useFavoriteMenuStyles = makeStyles((theme: ApplicationMuiTheme) => {
    return {
        favoriteAction: {
            color: theme?.app?.applicationColors.enumColors.white || colors.common.white,
            borderRadius: '2px',
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
            border: `1px solid ${theme?.app?.applicationColors.enumColors.white || colors.common.white}`,
            '&:hover': {
                backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
                border: `1px solid ${theme?.app?.applicationColors.enumColors.white || colors.common.white}`
            }
        },
        menu: {
            marginLeft: theme.spacing(0.75),
            borderRadius: '2px'
        },
        menuItemContent: { lineHeight: theme.spacing(1.375) + 'px' }
    };
});

type IFavoriteMenuProps = {
    isFavorited: boolean;
    onChange: () => unknown;
};

const FavoriteMenu: React.FC<IFavoriteMenuProps> = ({ isFavorited, onChange }) => {
    const classes = useFavoriteMenuStyles();
    const actionMenuRef = React.useRef<null | HTMLButtonElement>(null);
    const [ isActionMenuOpen, setIsActionMenuOpen ] = React.useState<boolean>(false);

    const theme = useTheme<ApplicationMuiTheme>();

    const handleIconClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        actionMenuRef.current = event.target as HTMLButtonElement;
        setIsActionMenuOpen(!isActionMenuOpen);
    };

    return (
        <>
            <MenuButton
                handleClick={handleIconClick}
                iconColor={isFavorited ?
                    (theme?.app?.clientTheme.colors.highlightColor1 || '#EDDA26')
                    : (theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf')}
                toolTip={isFavorited ? ActionTypes.un_favorite : ActionTypes.favorite}
                type={isFavorited ? ActionTypes.un_favorite : ActionTypes.favorite}
            />
            <Menu
                anchorEl={actionMenuRef.current}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                className={classes.menu}
                keepMounted
                onClose={() => setIsActionMenuOpen(!isActionMenuOpen)}
                open={isActionMenuOpen}
            >
                <MenuItem
                    className={classes.favoriteAction}
                    onClick={onChange}
                >
                    <Typography
                        className={classes.menuItemContent}
                        component='span'
                        noWrap={false}
                        variant='body2'
                    >
                        {isFavorited ? 'Remove' : 'Add to'}
                        <Typography
                            className={classes.menuItemContent}
                            display='block'
                            variant='body2'
                        >
                            Favorite
                        </Typography>
                    </Typography>
                </MenuItem>
            </Menu>
        </>
    );
};

export default FavoriteMenu;